"use strict";
var $ = require("../internals/export");
var fails = require("../internals/fails");
var isObject = require("../internals/is-object");
var classof = require("../internals/classof-raw");
var ARRAY_BUFFER_NON_EXTENSIBLE = require("../internals/array-buffer-non-extensible");
var $isSealed = Object.isSealed;
var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function() {
  $isSealed(1);
});
$({ target: "Object", stat: true, forced: FORCED }, {
  isSealed: function isSealed(it) {
    if (!isObject(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === "ArrayBuffer") return true;
    return $isSealed ? $isSealed(it) : false;
  }
});
